import React, { useEffect, useState } from "react";
import "../../CSS/AllChats.css";
import axios from "../axios";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import ContentLoading from "../miscellaneous/ContentLoading";
import { getSenderName, getAvatarPic } from "../config/ChatLogics";

import GroupModal from "../miscellaneous/GroupModal";

const AllChats = (props) => {
  const [chats, setChats] = useState();
  const [selectedChat, setSelectedChat] = useState();
  const [loggedUser, setLoggedUser] = useState();
  const [groupModal, setGroupModal] = useState(false);

  useEffect(() => {
    setLoggedUser(JSON.parse(localStorage.getItem("userInfo")));
    getChats();
  }, [props.selectedChat, props.getChatsAgain]);

  const getChats = async () => {
    try {
      const token = props.userInfo.token;
      await axios
        .get(`/chat`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setChats(res.data);
          props.getChats(res.data);
          // console.log("res.data(chats)", res.data);
        });
    } catch (error) {
      console.log("Error Occured", error);
    }
  };
  const openChat = async (chat) => {
    setSelectedChat(chat);
    props.openChatHandler(chat);
  };
  return (
    <>
      <div className="chats_header">
        <b>My Chats</b>
        <Button onClick={() => setGroupModal(true)}>
          New Group
          <AddIcon style={{ fontSize: "25px" }} />
        </Button>
      </div>
      {groupModal ? (
        <GroupModal
          userInfo={props.userInfo}
          chats={chats}
          groupModal={groupModal}
          setGroupModal={setGroupModal}
          selectedChatHandler={props.selectedChatHandler}
        />
      ) : null}
      {chats ? (
        <div>
          {chats.map((chat) => {
            return (
              <div
                className="chats_body"
                onClick={() => openChat(chat)}
                style={{
                  background:
                    selectedChat === chat && props.openChat === chat
                      ? "#38b2ac8f"
                      : "#d3d3d385",
                  color:
                    selectedChat === chat && props.openChat === chat
                      ? "white"
                      : "black",
                }}
                key={chat._id}
              >
                {/* <div className="chat_item">hello</div> */}
                <div className="chat_item">
                  {/* ============All Chats Avatars======== */}
                  {/* {!chat.isGroupChat ? (
                    <Avatar
                      src={getAvatarPic(loggedUser, chat.users)}
                      name={getSenderName(loggedUser, chat.users)}
                    />
                  ) : (
                    <Avatar
                      src={getSenderName(loggedUser, chat.users)}
                      name={getSenderName(loggedUser, chat.users)}
                    />
                  )} */}

                  {/* ============ All Chats Names ======== */}

                  {!chat.isGroupChat
                    ? getSenderName(loggedUser, chat.users)
                    : chat.chatName}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <ContentLoading />
      )}
    </>
  );
};

export default AllChats;
